module.exports = __webpack_public_path__ + "static/img/5.d919863.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/5.png
// module id = jUGQ
// module chunks = 0